const normalizeDescription = (description: string) =>
  description.trim().toLowerCase();

/**
 * Returns the ids of every item whose description clashes with the target
 * item's (target included), or an empty array if the target is unique.
 * Comparison ignores surrounding whitespace and letter case.
 */
export const getClashingDescriptionIds = (
  items: { id: string; description: string }[],
  targetId: string,
) => {
  const target = items.find(({ id }) => id === targetId);
  const targetDescription = normalizeDescription(target?.description || "");
  if (!targetDescription) {
    return [];
  }

  const clashingIds = items
    .filter(
      ({ description }) =>
        normalizeDescription(description) === targetDescription,
    )
    .map(({ id }) => id);

  return clashingIds.length > 1 ? clashingIds : [];
};
